
/* eslint-disable */
import { useEffect } from "react";
import { Button, Grid } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ChatModule from "../Chat";
import { hasAuthority } from "../../../utils/authorities";
import Datatable from "../../components/features/Datatable";
import Filter from "./Filter";
import {
  getQualityControlApprovedList,
  selectCoaFormCompleteList,
  selectIsLoading,
  selectApheresisResponse,
  clearApheresisResponse,
} from "../../slices/qualityApproval";
import { capitalizeWords } from "../../../utils/utils"
const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
  cycle: {
    label: "Cycle",
  },
};

const QualityApproval = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const qcApprovedData = useSelector(selectCoaFormCompleteList);
  const isLoading = useSelector(selectIsLoading);
  const apheresisResponse = useSelector(selectApheresisResponse);
  const tableData = {
    items: qcApprovedData?.items || qcApprovedData?.data || [],
    total_count:
      qcApprovedData?.pageDetails?.total_count ||
      qcApprovedData?.total_count ||
      0,
    page: qcApprovedData?.pageDetails?.page || 1,
    per_page: qcApprovedData?.pageDetails?.per_page || 10,
  };

  const handleServerSideChange = async (params) => {
    try {
      await dispatch(getQualityControlApprovedList(params));
    } catch (error) {
      console.error("Error fetching quality approval data:", error);
    }
  };



  // Initial data fetch
  useEffect(() => {
    if (hasAuthority(["approval-received-listing"], bmr_permissions)) {
      handleServerSideChange({ page: 1, per_page: 10 });
    }
  }, [bmr_permissions]);

  // Handle apheresis response
  useEffect(() => {
    if (apheresisResponse) {
      setTimeout(() => {
        dispatch(clearApheresisResponse());
      }, 3000);
    }
  }, [apheresisResponse, dispatch]);

  const columns = [
    {
      id: "subject_code",
      name: "Subject/Patient ID",
      selector: (row) => (row.patient_id ? row.patient_id : "N/A"),
      sortable: true,
    },
    {
      id: "subject_name",
      name: "Subject/Patient Name",
      selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
      sortable: true,
    },
    {
      id: "product",
      name: "Product/Phase",
      selector: (row) =>
        row.product && row.phase ? `${(row.product)}/${capitalizeWords(row.phase)}` : "N/A",
      sortable: true,
    },
    {
      id: "phase_type",
      name: "Type",
      selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
      sortable: true,
    },
    {
      id: "hospital_name",
      name: "Hospital/Site",
      selector: (row) => (row.hospital_name ? row.hospital_name : "N/A"),
      sortable: true,
    },
    {
      id: "approval_status",
      name: "Approved Status",
      selector: (row) =>
        row.approval_status ? (
          row.approval_status === "Approved" ? (
            <p className="text-[#00B278] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
              {row?.approval_status}
            </p>
          ) : row.approval_status === "Partially Approved" ? (
            <p className="text-[#F97316] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
              {row?.approval_status}
            </p>
          ) : row.approval_status === "Rejected" ||
            row.approval_status === "Pending" ? (
            <p className="text-[#FF2023] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
              {row?.approval_status}
            </p>
          ) : (
            <p className="text-gray-400 font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
              {row?.approval_status}
            </p>
          )
        ) : (
          "N/A"
        ),
      sortable: true,
    },
    { id: "stage", name: "Stage", selector: row => row.stage ? row.stage : "N/A", sortable: true },

    {
      id: "cycleObject",
      name: "Cycle",
      selector: (row) => {
        if (row.cycleObject) {
          const cycleValue = row.cycleObject;
          return (
            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium border border-blue-300 whitespace-nowrap">
              {cycleValue}
            </span>
          );
        }
        return "N/A";
      },
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex gap-2 relative">
          <Button
            onClick={() => {
              const qrId = row?.qr_code_generated_id;
              const feasibilityId = row?.id;
              navigate(`/bmr/qa/${qrId}?batch=${row.batch_no}`, {
                row: { row },
                state: [
                  { name: "Quality Approved", path: location.pathname },
                  {
                    name: "Details",
                    path: `/bmr/qa/${qrId}?batch=${row.batch_no}`,
                  },
                ],
              });
            }}
            key={row?.subject_id}
            size="small"
            className="!w-[100px]"
          >
            View Details
          </Button>
        </div>
      ),
    },
  ];



  return (
    <Grid
      container
      className="mt-4 ml-0 mr-3 mainDiv"
      rowSpacing={4.5}
      columnSpacing={2.75}
    >
      <Grid item xs={12} sx={{ mt: -2.25 }}>
        {hasAuthority(["approval-received-listing"], bmr_permissions) && (
          <div>
            <Datatable
              columns={columns}
              data={tableData}
              title="Subject/Patient"
              FilterComponent={Filter}
              onServerSideChange={handleServerSideChange}
              remote={true}
              filterConfig={filterConfig}
              loading={isLoading}
            />
            <ChatModule />
          </div>
        )}
      </Grid>
    </Grid>
  );
}

export default QualityApproval;
